var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgExportIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7802 5.65229L10.7803 4.16153L7.02931 7.91248C6.63879 8.303 6.00562 8.303 5.6151 7.91248C5.22458 7.52195 5.22458 6.88879 5.6151 6.49826L9.51178 2.60158L7.96644 2.6016C7.41415 2.6016 6.96643 2.15389 6.96643 1.60161C6.96642 1.04932 7.41413 0.601601 7.96642 0.601596L11.2803 0.601563C12.1088 0.601554 12.7803 1.27316 12.7803 2.10161L12.7802 5.65236C12.7802 6.20464 12.3325 6.65234 11.7802 6.65232C11.2279 6.65231 10.7802 6.20458 10.7802 5.65229ZM2.60621 1.81037C2.07911 1.81037 1.5736 2.01976 1.20088 2.39247C0.828164 2.76519 0.618774 3.2707 0.618774 3.7978V10.7099C0.618774 11.237 0.828165 11.7425 1.20088 12.1152C1.5736 12.4879 2.07911 12.6973 2.60621 12.6973H9.51828C10.0454 12.6973 10.5509 12.4879 10.9236 12.1152C11.2963 11.7425 11.5057 11.237 11.5057 10.7099V8.5234C11.5057 7.97111 11.058 7.5234 10.5057 7.5234C9.95343 7.5234 9.50571 7.97111 9.50571 8.5234V10.6973H2.61877V3.81037H4.79268C5.34497 3.81037 5.79268 3.36265 5.79268 2.81037C5.79268 2.25808 5.34497 1.81037 4.79268 1.81037H2.60621Z",
    fill: "#AFAFAF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportIcon);
export default __webpack_public_path__ + "static/media/export_icon.068f9f8103b43438f9d0d7c79ae3966d.svg";
export { ForwardRef as ReactComponent };